import PhotoGuide from "@/components/PhotoGuide";

export default function PhotoGuidePage() {
  return (
    <div className="min-h-screen bg-slate-950 px-4 py-8">
      <div className="max-w-3xl mx-auto space-y-6" data-testid="photo-guide-page">
        <div className="font-display text-xl tracking-[0.22em] text-slate-200">MIO</div>
        <div>
          <h1 className="font-display text-3xl text-slate-50">Guia das três fotografias</h1>
          <p className="text-sm text-slate-400 mt-2">Siga estas indicações para que as fotografias possam ser analisadas com qualidade.</p>
        </div>
        <PhotoGuide />
      </div>
    </div>
  );
}
